import ConnectionPlugin from './lib/index'

export default ConnectionPlugin